export const restMapActivity = {
  methods: {
    recordMapVisit(mapId) {
      if (!mapId) return
      const backendurl = this.$store.getters.backendurl
      this.$http.post(`${backendurl}api/v1/map-activity/visit`, { map_id: mapId })
        .catch((error) => { console.log('map-activity visit:', error) })
    }
  }
}
